import { createFileRoute } from '@tanstack/react-router';

import { NewExchangeRate } from './-components';

export const Route = createFileRoute('/admin/exchange-rates/_auth/new')({
  component: NewExchangeRate,
});
